export default "__VITE_ASSET__CsVGNdwm__"